import { Page } from '@/core/architecture'

import { ResaleApplicationCreateTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ResaleApplicationCreate Page
 * Implemented as a practical sample.
 */
export const ResaleApplicationCreate: Page = () => {
  const { state, actions } = useViewModel()

  return <ResaleApplicationCreateTemplate state={state} {...actions} />
}
